import { TextField } from 'src/components/Form/TextField';
import { SelectDateFieldBirthdate } from '../Form/SelectDateFieldBirthdate';

type PersonalDataFormProps = {
  creatingOrder: boolean;
};

const PersonalDataForm = ({ creatingOrder }: PersonalDataFormProps) => {
  return (
    <div className="mt-4 grid grid-flow-row grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
      <div className="col-span-2">
        <TextField
          name="name"
          label="Nome completo"
          caption="Preencha igual ao seu documento"
          autoComplete="name"
          isDisabled={!creatingOrder}
          isRequired
        />
      </div>

      <div className="col-span-2 sm:col-span-1">
        <TextField
          name="email"
          label="E-mail"
          type="email"
          autoComplete="email"
          isRequired
        />
      </div>

      <div className="col-span-2 sm:col-span-1">
        <TextField
          name="phone"
          label="Celular com DDD"
          placeholder="DDD + Número"
          type="tel"
          mask="phone"
          isRequired
        />
      </div>

      <div className="col-span-2 sm:col-span-1">
        <TextField
          name="cpf"
          label="CPF"
          placeholder="Apenas números"
          type="tel"
          mask="cpf"
          isDisabled={!creatingOrder}
          isRequired
        />
      </div>

      <div className="col-span-2 sm:col-span-1">
        <SelectDateFieldBirthdate
          name="birthdate"
          label="Data de nascimento"
          isDisabled={!creatingOrder}
        />
      </div>
    </div>
  );
};

export { PersonalDataForm };
